const actions = {
	GET_WRITE_FROM_DICTATION: 'GET_WRITE_FROM_DICTATION',
	GET_WRITE_FROM_DICTATION_SUCCESS: 'GET_WRITE_FROM_DICTATION_SUCCESS',

	CREATE_NEW_QUESTION_WRITE_FROM_DICTATION: 'CREATE_NEW_QUESTION_WRITE_FROM_DICTATION',
	CREATE_NEW_QUESTION_WRITE_FROM_DICTATION_SUCCESS: 'CREATE_NEW_QUESTION_WRITE_FROM_DICTATION_SUCCESS',

	DELETE_WRITE_FROM_DICTATION: 'DELETE_WRITE_FROM_DICTATION',
	DELETE_WRITE_FROM_DICTATION_SUCCESS: 'DELETE_WRITE_FROM_DICTATION_SUCCESS',

	GET_WRITE_FROM_DICTATION_DETAIL: 'GET_WRITE_FROM_DICTATION_DETAIL',
	GET_WRITE_FROM_DICTATION_DETAIL_SUCCESS: 'GET_WRITE_FROM_DICTATION_DETAIL_SUCCESS',

	UPDATE_WRITE_FROM_DICTATION_DETAIL: 'UPDATE_WRITE_FROM_DICTATION_DETAIL',
	UPDATE_WRITE_FROM_DICTATION_DETAIL_SUCCESS: 'UPDATE_WRITE_FROM_DICTATION_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getWriteFromDictation: (model) => ({
		type: actions.GET_WRITE_FROM_DICTATION,
		payload: { model },
	}),

	createQuesWriteFromDictation: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_WRITE_FROM_DICTATION,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getWriteFromDictationDetail: (id) => ({
		type: actions.GET_WRITE_FROM_DICTATION_DETAIL,
		payload: { id },
	}),

	updateWriteFromDictationDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_WRITE_FROM_DICTATION_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteWriteFromDictation: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_WRITE_FROM_DICTATION,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
